<template>
    <SimpleTablePage
        pageTitle="RPA"
        :columns="columns"
        :pageLength="pageLength"
        :pageLengthRank="pageLengthRank"
        :total="total"
        :dataset="dataset"
        :filters="searchFilter"
        :filterInit="queryData"
        :operationBtns="operationBtns"
        :footerOperationBtns="bottomButtons"
        :isHideFooter="false"
        @filterChange="filterFieldsChange"
        @pageChange="pageChange"
        @columnClick="columnClick"
        @bottomClick="bottomClick"
        @selectionChange="selectionChange"
    >
        <span class="sp-describe" slot="describe">
            共<span>{{ total }}</span
            >条RPA，<span>{{ onLineCount }}</span
            >条已上线，<span>{{ offLineCount }}</span
            >条已下线
        </span>
    </SimpleTablePage>
</template>

<script>
import SimpleTablePage from "@/views/zhiji/templates/simpleTablePage/index.vue";
import { columns, pageLength, pageLengthRank, searchFilter, bottomButtons, addRpaConfig, rules } from "./config";
import { queryRpaList, createRpa, updateRpa, deleteRpa } from "./server";
import { debounce } from "@/views/zhiji/js/common/util";
import FormModal from "@/views/zhiji/components/commonForm/FormModal.vue";

export default {
    name: "OnlineQATest",
    components: {
        SimpleTablePage
    },
    data() {
        return {
            columns,
            curPage: 1,
            pageLength,
            pageLengthRank,
            searchFilter,
            operationBtns: [
                {
                    text: "添加RPA",
                    type: "primary",
                    round: true,
                    onClick: this.addRpa,
                }
            ],
            bottomButtons,
            total: 0,
            onLineCount: 0,
            offLineCount: 0,
            dataset: [],
            queryData: {
                filterFields: {
                    order: "1",
                    status: "",
                    searchText: "",
                }
            },
            selectionList: [] // 列表选中项
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        }
    },
    created() {
        this.queryRpaListDebounce = debounce(() => this.queryRpaList(), 500);
        this.queryRpaListDebounce();

        this.handlers = {
            del: this.deleteAction, //删除
            online: this.onlineAction, //上线
            offline: this.offlineAction //下线
        };
    },
    methods: {
        async queryRpaList() {
            // 请求rpa数
            this.dataset = [];
            const { list = [], count = 0, offline_count, online_count } = await queryRpaList({
                page: this.curPage,
                size: this.pageLength,
                gameId: this.gameId,
                ...this.queryData.filterFields
            });
            this.dataset = list;
            this.total = count;
            this.offLineCount = offline_count;
            this.onLineCount = online_count;
        },
        filterFieldsChange(newFilter) {
            this.queryData = newFilter;
            this.queryRpaListDebounce();
        },
        pageChange(data) {
            const { curPage, pageLength } = data;
            this.curPage = curPage;
            this.pageLength = pageLength;
            this.queryRpaListDebounce();
        },
        columnClick(data) {
            // 表格操作按钮触发事件
            if (data.type === "Link") {
                // 进入RPA详情页
                this.$router.push({ path: "/zhijiservice/rpaedit", query: { rpaId: data.rowData.rpa_id } });
            } else if (data.type === "Operation") {
                // 单行click
                this.handlers[data.originEvent.value].call(null, [data.rowData.rpa_id]);
            }
        },
        bottomClick(data) {
            // 表格底部批量操作按钮触发事件
            if (this.selectionList.length === 0) {
                this.$confirm("请选择一条RPA!", "提示", {
                    distinguishCancelAndClose: true,
                    type: "warning",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                });
                return;
            }
            this.handlers[data.data.id].call(null, this.selectionList);
        },
        selectionChange(data) {
            // 取出id放到selectionList
            this.selectionList = data.map(item => item.rpa_id);
        },
        // 删除
        deleteAction(data) {
            const hasOnlineDate = data.some(item => this.dataset.some(val => val.status.text === " ● 已上线" && val.rpa_id === item));
            if (hasOnlineDate) {
                this.$confirm("已上线的RPA不可删除", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                return;
            }
            this.$confirm(`您确认删除这${data.length == 1 ? "条" : "些"}RPA吗?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    const res = await deleteRpa({
                        rpaIds: data.join(),
                        gameId: this.gameId
                    })
                    this.queryRpaListDebounce();
                    let deleMessage = "";
                    if (res.rpa_id.length === 1) {
                        deleMessage = "该RPA已删除";
                    } else {
                        deleMessage = `已删除${res.rpa_id.length}个RPA`;
                    }
                    this.$confirm(deleMessage, "提示", {
                        distinguishCancelAndClose: true,
                        type: "success",
                        confirmButtonText: "确定",
                        cancelButtonText: "取消"
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        async onlineAction(data) {
            const res = await updateRpa({
                rpaIds: data.join(),
                status: 1,
                gameId: this.gameId
            });
            this.queryRpaListDebounce();
            if (res.rpa_id) {
                let message = "";
                if (res.rpa_id.length === 1) {
                    message = "该RPA已上线";
                } else {
                    message = `已成功上线${res.rpa_id.length}个RPA`;
                }
                this.$confirm(message, "提示", {
                    distinguishCancelAndClose: true,
                    type: "success",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                });
            }
        },
        async offlineAction(data) {
            const res = await updateRpa({
                rpaIds: data.join(),
                status: 0,
                gameId: this.gameId
            });
            this.queryRpaListDebounce();
            if (res.rpa_id) {
                let message = "";
                if (res.rpa_id.length === 1) {
                    message = "该RPA已下线";
                } else {
                    message = `已成功下线${res.rpa_id.length}个RPA`;
                }
                this.$confirm(message, "提示", {
                    distinguishCancelAndClose: true,
                    type: "success",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                });
            }
        },
        async addRpa() {
            // 新增 刷新表
            this.$store.dispatch("zhiji/showModal", {
                type: FormModal,
                data: {
                    title: "添加RPA",
                    comps: addRpaConfig,
                    rules,
                    confirm: async forData => {
                        const { addRpa } = forData;
                        const request = {
                            rpa_name: addRpa.rpaName,
                            game_id: this.gameId
                        };
                        await createRpa(request);
                        this.queryRpaListDebounce();
                    }
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.sp-describe {
    font-weight: normal;
    margin-left: 24px;
    font-size: 14px;
    span {
        color: #26d485;
    }
}
.page-top-tips {
    display: inline-block;
    border: 1px solid #2ec2ff;
    border-radius: 3px;
    padding: 6px 8px;
    margin-bottom: 20px;
    color: #666;
    font-size: 12px;
    font-weight: 400;
    background-color: rgba(46, 194, 255, 0.06);
}
.online-tips {
    display: flex;
    position: relative;
    margin: 25px 0 8px 18px;
    font-size: 14px;
    color: #41475e;
    font-weight: 500;
    &::before {
        content: "";
        position: absolute;
        top: 7px;
        left: -15px;
        width: 4px;
        height: 8px;
        background: #03c972;
    }
}
.online-tips-text {
    color: #666;
    font-weight: 400;
    font-size: 12px;
    margin-left: 25px;
}
.tips-highlight {
    color: #fc9d00;
}
.jump-to-faq {
    color: #2ec2ff;
    &:hover {
        cursor: pointer;
    }
}
.real-algorithm-tips {
    font-size: 14px;
    margin: 20px 0 8px 18px;
    color: #41475e;
    font-weight: 500;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 7px;
        left: -15px;
        width: 4px;
        height: 8px;
        background: #2ec2ff;
    }
    span {
        margin-left: 10px;
        font-size: 12px;
        color: #999;
    }
}
</style>
